import React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

export type AutoSaveStatus = "idle" | "saving" | "saved" | "error";

interface AutoSaveIndicatorProps {
  status: AutoSaveStatus;
}

export const AutoSaveIndicator: React.FC<AutoSaveIndicatorProps> = ({
  status,
}) => {
  if (status === "idle") return null;

  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: 0.75,
        opacity: status === "saved" ? 0.7 : 1,
        transition: "opacity 0.3s ease",
      }}
    >
      {status === "saving" && (
        <CircularProgress
          size={14}
          thickness={5}
          sx={{ color: "rgba(255, 255, 255, 0.8)" }}
        />
      )}
      {status === "saved" && (
        <CheckIcon sx={{ fontSize: 16, color: "rgba(255, 255, 255, 0.8)" }} />
      )}
      {status === "error" && (
        <ErrorOutlineIcon sx={{ fontSize: 16, color: "#FCA5A5" }} />
      )}
      <Typography
        variant="caption"
        sx={{
          color:
            status === "error" ? "#FCA5A5" : "rgba(255, 255, 255, 0.8)",
          fontWeight: 500,
          lineHeight: 1,
          userSelect: "none",
        }}
      >
        {status === "saving" && "Saving..."}
        {status === "saved" && "Saved"}
        {status === "error" && "Error saving"}
      </Typography>
    </Box>
  );
};
